import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { ChatComponent, SplitPaneComponent } from '@components';
import { SplitPaneVerticalComponent, HistoryComponent } from '@components';

interface QualityGateDraft {
  minimumCoverage: number;
  maxCriticalLint: number;
  minTestPassRate: number;
  gateNotes: string;
}

@Component({
  selector: 'app-quality',
  templateUrl: './quality.page.html',
  styleUrls: ['./quality.page.scss'],
  standalone: true,
  imports: [
    RouterModule,
    FormsModule,
    ChatComponent,
    HistoryComponent,
    SplitPaneComponent,
    SplitPaneVerticalComponent
],
})
export class QualityPage {
  public qualitySuggestions: any[] = [
    { icon: 'bi bi-bar-chart', prompt: 'What is current coverage?' },
    { icon: 'bi bi-bug', prompt: 'List failing tests and owners' },
    { icon: 'bi bi-braces', prompt: 'Summarize lint issues by category' },
  ];

  public qualityContext: any = {
    page: 'quality',
    purpose: 'Track and improve code quality and test health',
    coverage: {},
    lintIssues: [],
    failingTests: [],
    outputs: ['Coverage trend', 'Top lint categories', 'Failure breakdown']
  };

  public evaluatingGate = false;
  public qualityError = '';
  public qualitySuccess = '';
  public hasEvaluatedGate = false;
  public qualityGateDraft: QualityGateDraft = {
    minimumCoverage: 80,
    maxCriticalLint: 0,
    minTestPassRate: 95,
    gateNotes: '',
  };

  constructor() {}

  public async evaluateQualityGate(): Promise<void> {
    this.qualityError = '';
    this.qualitySuccess = '';
    this.hasEvaluatedGate = false;

    if (this.qualityGateDraft.minimumCoverage < 1 || this.qualityGateDraft.minimumCoverage > 100) {
      this.qualityError = 'Minimum coverage must be between 1 and 100.';
      return;
    }
    if (this.qualityGateDraft.minTestPassRate < 1 || this.qualityGateDraft.minTestPassRate > 100) {
      this.qualityError = 'Minimum test pass rate must be between 1 and 100.';
      return;
    }

    this.evaluatingGate = true;
    try {
      await new Promise((resolve) => setTimeout(resolve, 700));
      this.hasEvaluatedGate = true;
      this.qualitySuccess = 'Quality gate evaluated and published for release checks.';
    } finally {
      this.evaluatingGate = false;
    }
  }
} 